import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Grid,
  TextField,
  FormHelperText,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Box,
  Tooltip,
  MenuItem,
} from "@mui/material";
import { Cross } from "../../../../shared/assets/icons";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

import TableChartIcon from "@mui/icons-material/TableChart";
import { statecityData } from "../../../../shared/enums";

import CustomInput from "../../../../shared/utils/Input";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import GlobalButton from "../../../../shared/utils/GlobalButton";
import axios from "axios";
import Chip from "@mui/material/Chip";
import FormatTimestamp from "../../../../helperFunctions/FormatDateTimestamp";
import styles from "../../../../styles/adminPortal.module.css";
import GlobalDropdownField from "../../../../shared/utils/GlobalDropdownField";

const headCells = [
  {
    id: "slotDate",
    label: "Slot Date",
    width: 100,
  },

  {
    id: "fromTime",
    label: "From Time",
    width: 100,
  },
  {
    id: "toTime",
    label: "To Time",
    width: 100,
  },

  {
    id: "maxSlot",
    label: "Slot Size",
    width: 100,
  },

  {
    id: "address",
    label: "Address",
    width: 180,
  },

  {
    id: "state",
    label: "State",
    width: 140,
  },
  {
    id: "city",
    label: "City",
    width: 140,
  },
  {
    id: "pincode",
    label: "PinCode",
    width: 100,
  },
  {
    id: "createdBy",
    label: "Created By",
    width: 100,
  },
  {
    id: "ipname",
    label: "IP Name",
    width: 100,
  },
  {
    id: "status",
    label: "Status",
    width: 140,
  },
  {
    id: "createdAt",
    label: "CreatedAt",
    width: 100,
  },
];

const CreateSlotIP = ({ createModal, setCreateModal }) => {
  const cityApiKey = process.env.REACT_APP_FETCH_STATE_CITY_API_KEY;
  dayjs.extend(utc);

  const [data, setData] = useState({
    dateForSlot: "",
    slotTimeFrom: "",
    slotTimeTo: "",
    maxTesters: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    addedBy: localStorage.getItem("userId"),
    updatedBy: localStorage.getItem("userId"),
  });
  const [cityArray, setCityArray] = useState([]);
  const [createTableModal, setCreateTableModal] = useState(false);
  const [errors, setErrors] = useState(null);
  const [saveButtonClicked, setSaveButtonClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [slotsTableData, setSlotsTableData] = useState([]);
  const [searchInputs, setSearchInputs] = useState({
    state: "",
    city: "",
  });

  // Uniform styling for all input fields with error border support
  const getInputStyles = (hasError) => ({
    width: "100%",
    "& .MuiInputBase-root": {
      height: "40px",
      fontSize: "0.875rem",
    },
    "& .MuiInputBase-input": {
      fontSize: "0.875rem",
      height: "100%",
      display: "flex",
      alignItems: "center",
    },
    "& .MuiSelect-select": {
      height: "100% !important",
      display: "flex !important",
      alignItems: "center !important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: hasError ? "var(--error-color)" : "rgba(0, 0, 0, 0.23)",
      },
      "&:hover fieldset": {
        borderColor: hasError ? "var(--error-color)" : "rgba(0, 0, 0, 0.87)",
      },
      "&.Mui-focused fieldset": {
        borderColor: hasError ? "var(--error-color)" : "var(--primary-color)",
      },
    },
  });

  const getDropdownStyles = (hasError) => ({
    width: "100%",
    "& .MuiInputBase-root": {
      height: "40px",
      fontSize: "0.875rem",
    },
    "& .MuiSelect-select": {
      height: "100% !important",
      minHeight: "auto !important",
      padding: "8px 12px !important",
      display: "flex !important",
      alignItems: "center !important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: hasError ? "var(--error-color)" : "rgba(0, 0, 0, 0.23)",
      },
      "&:hover fieldset": {
        borderColor: hasError ? "var(--error-color)" : "rgba(0, 0, 0, 0.87)",
      },
      "&.Mui-focused fieldset": {
        borderColor: hasError ? "var(--error-color)" : "var(--primary-color)",
      },
    },
  });

  const uniformLabelStyles = {
    color: "var(--heading-color)",
    fontFamily: "Helvetica",
    fontWeight: "400",
    fontSize: "1rem",
    marginBottom: "8px",
    display: "block",
  };

  const errorLabelStyles = {
    ...uniformLabelStyles,
    color: "var(--error-color)",
  };

  const validateForm = () => {
    const newErrors = {};

    if (!data.dateForSlot) newErrors.dateForSlot = "Date is required.";
    if (!data.slotTimeFrom)
      newErrors.slotTimeFrom = "Slot start time is required.";
    if (!data.slotTimeTo) newErrors.slotTimeTo = "Slot end time is required.";
    if (!data.maxTesters || isNaN(data.maxTesters) || data.maxTesters <= 0) {
      newErrors.maxTesters = "Enter valid max testers.";
    }
    if (!data.address) newErrors.address = "Address is required.";
    if (!data.city) newErrors.city = "City is required.";
    if (!data.state) newErrors.state = "State is required.";
    if (!data.zipCode || !/^\d{6}$/.test(data.zipCode)) {
      newErrors.zipCode = "Pin code must be a valid 6-digit number.";
    }

    setErrors(newErrors);

    // Return true if no errors
    return Object.keys(newErrors).length === 0;
  };
  const handleClose = () => {
    setCreateModal(false);
  };
  const [requiredFields, setRequiredFields] = useState({
    name: false,
    gender: false,
    address: false,
    phoneNumber: false,
    emailAddress: false,
    experience: false,
    state: false,
    city: false,
    zipCode: false,
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target; // Correct way to access name and value

    setData((prev) => {
      // If the input is "state", clear the "city" field
      if (name === "state") {
        return {
          ...prev,
          [name]: value, // Update the "state"
          city: "", // Clear the "city" field
        };
      }

      // For other fields, update as usual
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const handleKeyPress = (e) => {
    const { name, type } = e.target;
    const charCode = e.keyCode || e.which;

    if (name === "userName") {
      // Block characters that are not letters or spaces for the name input
      if (/[^a-zA-Z\s]/.test(e.key)) {
        e.preventDefault();
      }
    } else if (type === "number" || name === "phoneNumber") {
      // Block 'e', 'E', '-', '+', and '.' for phone number input
      if ([69, 101, 43, 45, 46].includes(charCode)) {
        e.preventDefault();
      }
    }
  };
  const emptyInputCheck = (fieldName, value) => {
    if (value === "") {
      setRequiredFields({ ...requiredFields, [fieldName]: true });
    } else {
      setRequiredFields({ ...requiredFields, [fieldName]: false });
    }
  };
  useEffect(() => {
    const stateCode = statecityData.find(
      (ele) => ele.name === data.state,
    )?.iso2;

    if (data.state) {
      const fetchCities = async (stateCode) => {
        const headers = new Headers();
        headers.append("X-CSCAPI-KEY", cityApiKey);

        const requestOptions = {
          method: "GET",
          headers: headers,
          redirect: "follow",
        };

        try {
          const response = await fetch(
            `https://api.countrystatecity.in/v1/countries/IN/states/${stateCode}/cities`,
            requestOptions,
          );

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const cityData = await response.json();
          setCityArray(cityData);

          // Log the city names
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      };

      // Example usage: Fetch cities in Maharashtra (state code "MH")
      fetchCities(stateCode);
    }
  }, [data.state]);

  const serverURL = process.env.REACT_APP_URL;
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!validateForm()) {
        Swal.fire({
          customClass: {
            container: "my-swal",
          },
          icon: "error",
          text: "Something Went Wrong",
          color: "black",
        });
        return; // Prevent further execution if form is not valid
      }

      setIsLoading(true);

      const response = await axios.post(
        `${serverURL}/installationPartner/createSlot`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (response.data.success) {
        Swal.fire({
          customClass: {
            container: "my-swal",
          },
          icon: "success",
          text: response.data.message,
          padding: "1em",
          color: "black",
        }).then(() => {
          setCreateModal(false);
        });
      } else {
        Swal.fire({
          customClass: {
            container: "my-swal",
          },
          icon: "error",
          text: response.data.error,
          padding: "1em",
          color: "black",
        });
      }
    } catch (error) {
      console.error("Error during form submission:", error);
      Swal.fire({
        customClass: {
          container: "my-swal",
        },
        icon: "error",
        text: "An unexpected error occurred. Please try again.",
        color: "black",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getAllSlotsData = async () => {
    try {
      const response = await axios.get(
        `${serverURL}/installationPartner/getAllSlots`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (response?.data?.success) {
        setSlotsTableData(response?.data?.data);
      } else {
        console.log("Unexpected response format");
        Swal.fire({
          customClass: {
            container: "my-swal",
          },
          icon: "error",
          text: response.data?.error || "An unexpected error occurred",
          padding: "1em",
          color: "black",
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);

      // Swal.fire({
      //   customClass: {
      //     container: "my-swal",
      //   },
      //   icon: "error",
      //   text: error.response?.data?.error || "Failed to load slots. Please try again.",
      //   padding: "1em",
      //   color: "black",
      // });
    }
  };

  const fetchSlots = async (queryParams) => {
    try {
      const response = await axios.get(
        `${serverURL}/installationPartner/getAllSlots?${queryParams}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (response?.data?.success) {
        setSlotsTableData(response?.data?.data);
      } else {
        console.log("Unexpected response format");
        Swal.fire({
          customClass: {
            container: "my-swal",
          },
          icon: "error",
          text: response.data?.error || "An unexpected error occurred",
          padding: "1em",
          color: "black",
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);

      // Swal.fire({
      //   customClass: {
      //     container: "my-swal",
      //   },
      //   icon: "error",
      //   text: error.response?.data?.error || "Failed to load slots. Please try again.",
      //   padding: "1em",
      //   color: "black",
      // });
    }
  };

  const handleTableOpen = async (e) => {
    e.preventDefault();
    setCreateTableModal(true);
    getAllSlotsData();
  };

  const handleTableClose = () => {
    setCreateTableModal(false);
  };

  const handleSearchChangeHead = async (e, key) => {
    const value = e.target.value.toLowerCase();

    setSearchInputs((prevState) => {
      const updatedInputs = { ...prevState, [key]: value };

      const allFieldsEmpty = Object.values(updatedInputs).every(
        (val) => val.trim() === "",
      );

      if (allFieldsEmpty) {
        getAllSlotsData();
        return updatedInputs;
      }

      // Set a new timeout of 3 seconds before sending the API request
      // debounceTimeout = setTimeout(() => {
      // Construct API Query Parameters based on filled fields
      let queryParams = new URLSearchParams();

      Object.entries(updatedInputs).forEach(([searchKey, searchValue]) => {
        if (searchValue.trim() !== "") {
          queryParams.append(searchKey, searchValue);
        }
      });

      // Call API with filtered search parameters after 3 seconds
      fetchSlots(queryParams.toString());

      return updatedInputs;
    });
  };

  return (
    <div>
      <Dialog open={createModal} maxWidth="md" fullWidth>
        <div className="flex flex-col">
          <div className="flex justify-between items-center">
            <DialogTitle
              sx={{
                fontWeight: "bold", // Set the font weight to bold
                fontSize: {
                  xs: "1.15rem", // Font size for extra-small screens (mobile)
                  sm: "1.5rem", // Font size for small screens and above
                },
              }}
            >
              Slot for Installation Partner
            </DialogTitle>
            <div className="hidden sm:block mr-2">
              <GlobalButton
                variant="primary"
                size="medium"
                onClick={handleTableOpen}
              >
                {`Slot Table`}
              </GlobalButton>
            </div>
          </div>

          <div className="flex justify-center sm:hidden mb-4">
            <Button
              variant="contained"
              color="success"
              onClick={handleTableOpen}
            >
              Slot Table
            </Button>
          </div>
        </div>

        <DialogContent>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4}>
                <Box>
                  <h3
                    style={
                      errors?.dateForSlot
                        ? errorLabelStyles
                        : uniformLabelStyles
                    }
                  >
                    Date For Slot *
                  </h3>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      // label="Date for Slot"
                      value={data?.startDate || null}
                      onChange={(date) => {
                        if (date) {
                          const localDate = dayjs(date)
                            .utcOffset(0, true)
                            .format("YYYY-MM-DD");
                          handleInputChange({
                            target: { name: "dateForSlot", value: localDate },
                          });
                        }
                      }}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          error: Boolean(errors?.dateForSlot),
                          sx: getInputStyles(Boolean(errors?.dateForSlot)),
                        },
                        // Add hover effect and color to calendar icon
                        inputAdornment: {
                          sx: {
                            "& .MuiIconButton-root": {
                              cursor: "pointer",
                              borderRadius: "50px",
                              padding: "4px",
                              transition: "background-color 0.2s ease-in-out",
                              "&:hover": {
                                backgroundColor: "rgba(0, 0, 0, 0.1)", // Same hover effect as clock icons
                              },
                              // Change calendar icon color to match clock icons
                              "& .MuiSvgIcon-root": {
                                color: "#757575", // Same color as clock icons
                                filter:
                                  "invert(0.45) sepia(0) saturate(0) hue-rotate(0deg)",
                              },
                            },
                          },
                        },
                      }}
                      minDate={dayjs()}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          error={Boolean(errors?.dateForSlot)}
                          helperText={errors?.dateForSlot && "Select Date"}
                          sx={getInputStyles(Boolean(errors?.dateForSlot))}
                        />
                      )}
                      required
                      format="DD/MM/YYYY"
                    />
                  </LocalizationProvider>
                  {errors?.dateForSlot && (
                    <FormHelperText
                      sx={{
                        color: "var(--error-color)",
                        marginTop: 1,
                        marginLeft: 1.5,
                      }}
                    >
                      Select date for slot.
                    </FormHelperText>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box>
                  <h3
                    style={
                      errors?.slotTimeFrom
                        ? errorLabelStyles
                        : uniformLabelStyles
                    }
                  >
                    Slot Time From *
                  </h3>
                  <TextField
                    id="time-picker"
                    // label="Slot Time From "
                    name="slotTimeFrom"
                    onChange={handleInputChange}
                    value={data.slotTimeFrom}
                    type="time"
                    defaultValue="12:00"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      step: 300, // 5 min
                      placeholder: "HH:MM",
                    }}
                    fullWidth
                    error={Boolean(errors?.slotTimeFrom)}
                    sx={{
                      ...Boolean(errors?.slotTimeFrom),
                      "& .MuiInputBase-root": {
                        height: "40px",
                      },
                      // Add placeholder styling
                      "& input::placeholder": {
                        color: "#9e9e9e",
                        opacity: 1,
                        fontSize: "1rem",
                      },
                      "& input::-webkit-datetime-edit": {
                        color: data.slotTimeFrom ? "inherit" : "#9e9e9e",
                      },
                      // Style the clock icon to match placeholder color with hover effect
                      "& input[type='time']::-webkit-calendar-picker-indicator":
                        {
                          filter:
                            "invert(0.45) sepia(0) saturate(0) hue-rotate(0deg)", // Matches #757575
                          cursor: "pointer",
                          borderRadius: "50px",
                          padding: "4px",
                          transition: "background-color 0.2s ease-in-out",
                          "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.2)", // Same hover effect as calendar icon
                          },
                        },
                      // For Firefox
                      "& input[type='time']::-moz-calendar-picker-indicator": {
                        filter:
                          "invert(0.45) sepia(0) saturate(0) hue-rotate(0deg)",
                        cursor: "pointer",
                        borderRadius: "50px",
                        padding: "4px",
                        transition: "background-color 0.2s ease-in-out",
                        "&:hover": {
                          backgroundColor: "rgba(0, 0, 0, 0.2)",
                        },
                      },
                    }}
                  />
                  {errors?.slotTimeFrom && (
                    <FormHelperText
                      sx={{
                        color: "var(--error-color)",
                        marginTop: 1,
                        marginLeft: 1.5,
                      }}
                    >
                      {errors?.slotTimeFrom}
                    </FormHelperText>
                  )}
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Box>
                  <h3
                    style={
                      errors?.slotTimeTo ? errorLabelStyles : uniformLabelStyles
                    }
                  >
                    Slot Time To *
                  </h3>
                  <TextField
                    id="time-picker"
                    // label="Slot Time To "
                    name="slotTimeTo"
                    onChange={handleInputChange}
                    value={data.slotTimeTo}
                    type="time"
                    defaultValue="12:00"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      step: 300, // 5 min
                      placeholder: "HH:MM",
                    }}
                    fullWidth
                    error={Boolean(errors?.slotTimeTo)}
                    sx={{
                      ...Boolean(errors?.slotTimeTo),
                      "& .MuiInputBase-root": {
                        height: "40px",
                      },
                      // Add placeholder styling
                      "& input::placeholder": {
                        color: "#9e9e9e",
                        opacity: 1,
                        fontSize: "1rem",
                      },
                      "& input::-webkit-datetime-edit": {
                        color: data.slotTimeTo ? "inherit" : "#9e9e9e",
                      },
                      // Style the clock icon to match placeholder color with hover effect
                      "& input[type='time']::-webkit-calendar-picker-indicator":
                        {
                          filter:
                            "invert(0.45) sepia(0) saturate(0) hue-rotate(0deg)", // Matches #757575
                          cursor: "pointer",
                          borderRadius: "50px",
                          padding: "4px",
                          transition: "background-color 0.2s ease-in-out",
                          "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.2)", // Same hover effect as calendar icon
                          },
                        },
                    }}
                  />
                  {errors?.slotTimeTo && (
                    <FormHelperText
                      sx={{
                        color: "var(--error-color)",
                        marginTop: 1,
                        marginLeft: 1.5,
                      }}
                    >
                      {errors?.slotTimeTo}
                    </FormHelperText>
                  )}
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Box>
                  <h3
                    style={
                      errors?.maxTesters ? errorLabelStyles : uniformLabelStyles
                    }
                  >
                    Max Slot Size *
                  </h3>
                  <TextField
                    name="maxTesters"
                    placeholder="Max Testers"
                    value={data?.maxTesters}
                    type="number"
                    error={Boolean(errors?.maxTesters)}
                    required
                    onChange={(e) => {
                      let value = e.target.value;
                      if (
                        !value.startsWith(" ") &&
                        value.length <= 3 &&
                        Number(value) >= 0
                      ) {
                        handleInputChange(e);
                      }
                    }}
                    onKeyPress={(e) => handleKeyPress(e)}
                    onFocus={(e) => {
                      e.target.addEventListener(
                        "wheel",
                        (event) => {
                          event.preventDefault();
                        },
                        { passive: false },
                      );
                    }}
                    onBlur={(e) => {
                      e.target.removeEventListener("wheel", (event) => {
                        event.preventDefault();
                      });
                    }}
                    sx={getInputStyles(Boolean(errors?.maxTesters))}
                    inputProps={{
                      style: {
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                      },
                    }}
                  />
                  {errors?.maxTesters && (
                    <FormHelperText
                      sx={{
                        color: "var(--error-color)",
                        marginTop: 1,
                        marginLeft: 1.5,
                      }}
                    >
                      {errors?.maxTesters}
                    </FormHelperText>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={9}>
                <Box>
                  <h3
                    style={
                      errors?.address ? errorLabelStyles : uniformLabelStyles
                    }
                  >
                    Address *
                  </h3>
                  <TextField
                    placeholder="Address"
                    value={data.address}
                    type="text"
                    name="address"
                    error={Boolean(errors?.address)}
                    onChange={(e) => {
                      if (!e.target.value.startsWith(" ")) {
                        handleInputChange(e);
                      }
                    }}
                    onBlur={(e) => {
                      if (saveButtonClicked) {
                        validateForm();
                      }
                    }}
                    sx={getInputStyles(Boolean(errors?.address))}
                    inputProps={{
                      style: {
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                      },
                    }}
                  />
                  {errors?.address && (
                    <FormHelperText
                      sx={{
                        color: "var(--error-color)",
                        marginTop: 1,
                        marginLeft: 1.5,
                      }}
                    >
                      {errors?.address}
                    </FormHelperText>
                  )}
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Box>
                  <h3
                    style={
                      errors?.state ? errorLabelStyles : uniformLabelStyles
                    }
                  >
                    State *
                  </h3>
                  <TextField
                    select
                    name="state"
                    value={data?.state || ""}
                    onChange={handleInputChange}
                    error={Boolean(errors?.state)}
                    sx={getDropdownStyles(Boolean(errors?.state))}
                    SelectProps={{
                      displayEmpty: true,
                      renderValue: (selected) => {
                        if (!selected || selected === "") {
                          return (
                            <p
                              style={{
                                color: "#9e9e9e",
                                fontSize: "14px", // Match typical input placeholder size
                                margin: 0,
                                fontFamily: "inherit", // Ensure same font family
                                fontWeight: "normal", // Ensure normal weight
                              }}
                            >
                              Select State
                            </p>
                          );
                        }
                        return selected;
                      },
                    }}
                  >
                    <MenuItem value="">
                      <em>Select State</em>
                    </MenuItem>
                    {statecityData.map((state) => (
                      <MenuItem key={state.name} value={state.name}>
                        {state.name}
                      </MenuItem>
                    ))}
                  </TextField>
                  {errors?.state && (
                    <FormHelperText
                      sx={{
                        color: "var(--error-color)",
                        marginTop: 1,
                        marginLeft: 1.5,
                      }}
                    >
                      {errors?.state}
                    </FormHelperText>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box>
                  <h3
                    style={errors?.city ? errorLabelStyles : uniformLabelStyles}
                  >
                    City *
                  </h3>
                  <TextField
                    select
                    name="city"
                    value={data?.city || ""}
                    onChange={handleInputChange}
                    error={Boolean(errors?.city)}
                    sx={getDropdownStyles(Boolean(errors?.city))}
                    SelectProps={{
                      displayEmpty: true,
                      renderValue: (selected) => {
                        if (!selected || selected === "") {
                          return (
                            <p
                              style={{
                                color: "#9e9e9e",
                                fontSize: "14px",
                                margin: 0,
                                fontFamily: "inherit",
                                fontWeight: "normal",
                              }}
                            >
                              Select City
                            </p>
                          );
                        }
                        return selected;
                      },
                    }}
                  >
                    <MenuItem value="">
                      <em>Select State First</em>
                    </MenuItem>
                    {cityArray.map((city) => (
                      <MenuItem key={city.name} value={city.name}>
                        {city.name}
                      </MenuItem>
                    ))}
                  </TextField>
                  {errors?.city && (
                    <FormHelperText
                      sx={{
                        color: "var(--error-color)",
                        marginTop: 1,
                        marginLeft: 1.5,
                      }}
                    >
                      {errors?.city}
                    </FormHelperText>
                  )}
                </Box>
              </Grid>
              {/* Pin Code */}
              <Grid item xs={12} sm={6} md={3}>
                <Box>
                  <h3
                    style={
                      errors?.zipCode ? errorLabelStyles : uniformLabelStyles
                    }
                  >
                    Pin Code *
                  </h3>
                  <TextField
                    placeholder="Enter Your Pin Code"
                    type="number"
                    name="zipCode"
                    error={Boolean(errors?.zipCode)}
                    value={data?.zipCode}
                    onChange={(e) => {
                      const value = e.target.value;

                      // Allow only up to 6 digits and no leading spaces
                      if (
                        !value.startsWith(" ") &&
                        value.length <= 6 &&
                        Number(value) >= 0
                      ) {
                        handleInputChange(e);
                      }
                    }}
                    onFocus={(e) => {
                      e.target.addEventListener(
                        "wheel",
                        (event) => {
                          event.preventDefault();
                        },
                        { passive: false },
                      );
                    }}
                    onBlur={(e) => {
                      e.target.removeEventListener("wheel", (event) => {
                        event.preventDefault();
                      });
                    }}
                    sx={getInputStyles(Boolean(errors?.zipCode))}
                    inputProps={{
                      style: {
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                      },
                    }}
                  />
                  {errors?.zipCode && (
                    <FormHelperText
                      sx={{
                        color: "var(--error-color)",
                        marginTop: 1,
                        marginLeft: 1.5,
                      }}
                    >
                      {errors?.zipCode}
                    </FormHelperText>
                  )}
                </Box>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <div className="w-30">
            <GlobalButton
              variant="secondary"
              size="medium"
              onClick={handleClose}
            >
              {`Close`}
            </GlobalButton>
          </div>
          <div className="w-30">
            <GlobalButton
              variant="primary"
              size="medium"
              isLoading={isLoading}
              onClick={(e) => {
                setSaveButtonClicked(true);
                handleSubmit(e);
              }}
            >
              {`CREATE`}
            </GlobalButton>
          </div>
        </DialogActions>
      </Dialog>

      <Dialog open={createTableModal} maxWidth="xl" fullWidth>
        <div className="flex">
          <DialogTitle
            sx={{
              fontWeight: "bold",
              fontSize: { xs: "1.15rem", sm: "1.5rem" },
            }}
          >
            Slots Table ({slotsTableData?.length || 0})
          </DialogTitle>
        </div>

        {/* Table Section */}
        <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
          <Table stickyHeader>
            <TableHead className={styles.tableHead}>
              <TableRow>
                {headCells.map((headCell, index) => (
                  <TableCell
                    key={headCell.id}
                    className={styles.tableCell}
                    sx={{
                      minWidth: headCell.width,
                    }}
                  >
                    <span className="absolute top-2"> {headCell.label} </span>
                    <div className={styles.topBorderDiv}>
                      {["state", "city"].includes(headCell.id) && (
                        <input
                          type="text"
                          className={styles.searchInput}
                          placeholder={`Search...`}
                          onChange={(e) =>
                            handleSearchChangeHead(e, headCell.id)
                          }
                          value={searchInputs?.[headCell.id] || ""}
                        />
                      )}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {slotsTableData && slotsTableData?.length > 0 ? (
                slotsTableData?.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell className={styles.tableRow}>
                      <FormatTimestamp timestamp={row?.dateForSlot} />
                    </TableCell>
                    <TableCell className={styles.tableRow}>
                      <span>{row?.slotTimeFrom}</span>
                    </TableCell>
                    <TableCell className={styles.tableRow}>
                      <span>{row?.slotTimeTo}</span>
                    </TableCell>
                    <TableCell className={styles.tableRow}>
                      <span>{row?.maxTesters}</span>
                    </TableCell>
                    <TableCell className={styles.tableRow}>
                      <span>
                        <Tooltip title={row.address} arrow placement="top">
                          <span className={styles.truncateText}>
                            {row.address
                              ? row?.address?.length > 17
                                ? row?.address.charAt(0).toUpperCase() +
                                  row?.address.slice(1, 17) +
                                  "..."
                                : row?.address.charAt(0).toUpperCase() +
                                  row?.address.slice(1)
                              : "NA"}
                          </span>
                        </Tooltip>
                      </span>
                    </TableCell>
                    <TableCell className={styles.tableRow}>
                      <span>{row?.state}</span>
                    </TableCell>
                    <TableCell className={styles.tableRow}>
                      <span>{row?.city}</span>
                    </TableCell>
                    <TableCell className={styles.tableRow}>
                      <span>{row?.zipCode}</span>
                    </TableCell>
                    <TableCell className={styles.tableRow}>
                      <span>{row?.addedBy?.name}</span>
                    </TableCell>
                    <TableCell className={styles.tableRow}>
                      <span>{row?.installationPartner?.name || "N/A"}</span>
                    </TableCell>
                    <TableCell>
                      <div className="flex justify-center">
                        <Chip
                          label={row?.assignedStatus}
                          sx={{
                            backgroundColor: `${
                              row?.assignedStatus === "Assigned"
                                ? "#DDFFD3"
                                : "#FFDFDF"
                            }`, // Custom background color
                            color: `${
                              row?.assignedStatus === "Assigned"
                                ? "#358C09"
                                : "#8C0909"
                            }`, // Custom text color
                          }}
                        />
                      </div>
                    </TableCell>

                    <TableCell className={styles.tableRow}>
                      <span>
                        <FormatTimestamp timestamp={row.createdAt} />
                      </span>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={9}
                    align="center"
                    style={{ height: "300px" }}
                  >
                    No Slots Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <DialogActions>
          <div className="w-30">
            <GlobalButton
              variant="primary"
              size="medium"
              onClick={handleTableClose}
            >
              {`Close`}
            </GlobalButton>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CreateSlotIP;
